/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TWebCreateSubscriptionRequest,
  TWebCreateSubscriptionModel,
  IMappers,
  TWebCreateSubscriptionResponse,
  TWebCreateSubscriptionResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createWebCreateSubscriptionModel(
  parameters: TWebCreateSubscriptionRequest,
): TWebCreateSubscriptionModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'saved-searches',
    pathApi: '/v1/web/create-subscription/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IWebCreateSubscriptionOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TWebCreateSubscriptionRequest;
}

export async function fetchWebCreateSubscription<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IWebCreateSubscriptionOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TWebCreateSubscriptionResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createWebCreateSubscriptionModel(parameters),
    config,
  )) as FetchResponse<TWebCreateSubscriptionResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TWebCreateSubscriptionResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TWebCreateSubscriptionResponse>;
}
